(function ($, Drupal, once) {
  class CustomDate {
    constructor($dateInput) {
      if (!$dateInput.attr('disabled')) {
        this.id = $dateInput.attr('id');
        $dateInput.removeAttr('id');

        this.$customInput = $(
          `<input type="text" id="${
            this.id
          }" placeholder="Date" class="custom-date ${$dateInput.attr(
            'class',
          )} "/>`,
        );
        this.$dateInput = $dateInput;
        this.$dateInput.after(this.$customInput);
        this.$dateInput.addClass('visually-hidden');

        this.$customInput.on('focus', this.onFocus.bind(this));
        this.$dateInput.on('input', this.mapDate.bind(this));
        this.$dateInput.on('change', this.mapDate.bind(this));
        this.mapDate();
      }
    }

    onFocus() {
      this.$dateInput.focus();
      this.$dateInput[0].showPicker();
    }

    mapDate() {
      const timestamp = Date.parse(this.$dateInput.val());
      if (isNaN(timestamp)) {
        this.$customInput.val('');
        return;
      }

      const formattedDate = new Intl.DateTimeFormat('en-GB', {
        day: 'numeric',
        month: 'short',
        year: '2-digit',
      }).format(new Date(timestamp));
      this.$customInput.val(formattedDate);
    }
  }

  Drupal.behaviors.veoliaDate = {
    attach: (context) => {
      $(once('input-date', 'input[type="date"]', context)).each(function () {
        new CustomDate($(this));
      });

      const rowCount = $('.add-waste-type-wrapper table tr').length;
      if (rowCount <= 2) {
        $('.add-waste-type-wrapper table').addClass('singletr');
      }
    },
  };
}(jQuery, Drupal, once));
